import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d0fb806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-item" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "menu-item__label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  "aria-hidden": "true",
  class: "menu-item__divider"
}, null, -1))

interface Props {
  label: string
  note?: string
  image?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectItemWithIcon',
  props: {
    label: {},
    note: {},
    image: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.image,
            alt: _ctx.label + ' icon',
            width: "32",
            height: "32",
            class: "mr-[16px]"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        (_ctx.note)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.note), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_5
  ], 64))
}
}

})